import { useContext } from "react";
import { Button, OverlayTrigger, Table, Tooltip, Badge } from "react-bootstrap";
import { CheckCircle, CheckSquare, Trash } from "react-feather";

export default function BatchStudentsTable({ students}) {
    return (
        <Table fluid bordered hover>
            <thead className="table-light">
                <tr
                    style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                    }}
                >
                    <th>Actions</th>
                    <th>S.No</th>
                    <th>Student Name</th>
                    <th>FIN</th>
                    <th>Sponsor Company</th>
                    {/* <th>Attendance</th> */}
                </tr>
            </thead>
            <tbody>
                {students?.map((data, index) => (
                    <tr key={data?.id ?? index}>
                        <td className="text-center">
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>BCA Attendance</Tooltip>}
                            >
                                <a
                                    href={`/tms/bca-attendance/create/${data?.id}`}
                                    rel="noreferrer"
                                    className="me-1"
                                >
                                    <span>
                                        <CheckSquare
                                            size="18"
                                            color="#6c757d"
                                        />
                                    </span>
                                </a>
                            </OverlayTrigger>
                        </td>
                        <td>{index + 1}</td>
                        <td>{data?.enrolment?.name ?? ""}</td>
                        <td>{data?.enrolment?.fin ?? ""}</td>
                        <td>
                            {data?.enrolment?.sponsor_company?.name ?? "N/A"}
                        </td>
                        {/* <td>
                            {" "}
                            <Badge
                                className="border bg-success bg-opacity-25 border-success text-success rounded-3 px-3 py-2"
                            >
                                <span className="fw-bold">Signed</span>
                            </Badge>
                        </td> */}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
